import React, { useState } from 'react';
import styles from "./createAccount.module.css"
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { createAccount } from '../../../redux/loginSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { setData, setMode, setVisible } from '../../../redux/authModelSlice';
// import PhoneInput from 'react-phone-input-2';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';


const CreateAccount = () => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const { visible } = useSelector(state => state.model)

    const openOtpModal = (value, mode) => {
        dispatch(setData(value))
        dispatch(setMode(mode))

        dispatch(setVisible('otp'))
    };

    const schema = yup.object().shape({
        firstName: yup.string().required("First name is required"),
        lastName: yup.string().required("Last name is required"),
        email: yup.string()
            .email("Please enter a valid email")
            .required("Email is required"),
        phone: yup.string().matches(/^\+?\d{12,15}$/, "Invalid contact number").required("Contact number is required"),
    });

    const {
        errors, values, handleChange, touched, handleBlur, handleSubmit, resetForm, setFieldValue
    } = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
        },
        validationSchema: schema,
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const payload = {
                    ...values,
                    phone: values.phone.replace(/\D/g, "")
                };
                const result = await dispatch(createAccount(payload));
                unwrapResult(result)
                resetForm()
                const mode = 'signup'
                openOtpModal(payload, mode);
            } catch (error) {
                console.error('Login failed:', error);
            } finally {
                setLoading(false);
            }
        }
    });

    if (visible != 'signup') {
        return null
    }

    const showvalue = (phone) => {
        console.log(phone);
    }


    return (
        <>
            <div className={styles.popupOverlay} >
                <div className={styles.login_container} >

                    <div className={styles.image_section}>
                        <img src="/assets/loginImg.jpeg" alt="login" />
                    </div>

                    <div className={styles.form_section} >
                        <button className={styles.closeButton} onClick={() => dispatch(setVisible(''))}>
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M23.6841 8.31641L8.31633 23.6842" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" />
                                <path d="M23.6833 23.6855L8.3156 8.3178" stroke="#C4C4C4" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </button>
                        <div className={styles.formLogo}>
                            <img src="/pavithrajewelslogo.png" alt="logo" />
                        </div>
                        <h2>CREATE AN ACCOUNT</h2>
                        <p className={styles.form_text}>Please register or sign in.</p>

                        <div className={styles.form_container}>
                            <div className={styles.inputCont}>
                                <label>First name</label>
                                <input type="text" name="firstName" autoComplete="given-name" placeholder='Enter your first name...' value={values.firstName} onChange={handleChange} />
                                {errors.firstName && touched.firstName && <div style={{ fontSize: 12, color: '#FE671F' }}>{errors.firstName}</div>}
                            </div>
                            <div className={styles.inputCont}>
                                <label>Last name</label>
                                <input type="text" name="lastName" autoComplete="family-name" placeholder="Enter your last name..." value={values.lastName} onChange={handleChange} />
                                {errors.lastName && touched.lastName && <div style={{ fontSize: 12, color: '#FE671F' }}>{errors.lastName}</div>}
                            </div>
                            <div className={styles.inputCont}>
                                <label>Phone Number</label>

                                <PhoneInput
                                    defaultCountry="in"
                                    value={values.phone}
                                    onChange={(value) => setFieldValue("phone", value)}
                                    onBlur={handleBlur}
                                    name="phone"
                                    className={styles.phoneInput}
                                />
                                {errors.phone && touched.phone && <div style={{ fontSize: 12, color: '#FE671F' }}>{errors.phone}</div>}
                            </div>
                            <div className={styles.inputCont}>
                                <label>Email Address</label>
                                <input type="text" id="email" name="email" autoComplete="email" placeholder="Enter your email..." value={values.email} onChange={handleChange} />
                                {errors.email && touched.email && <div style={{ fontSize: 12, color: '#FE671F' }}>{errors.email}</div>}
                            </div>
                            <button type="submit" onClick={handleSubmit} className={styles.formButton}>
                                {loading ? 'Loading' : 'Register'}
                            </button>
                            <p className={styles.signup} onClick={() => dispatch(setVisible('signin'))}>
                                Sign in
                                <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="10.5" y="9.09375" width="0.802992" height="5.62095" transform="rotate(-45 10.5 9.09375)" fill="black" />
                                    <rect x="14.4756" y="11.9336" width="0.802992" height="5.62095" transform="rotate(45 14.4756 11.9336)" fill="black" />
                                </svg>
                            </p>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default CreateAccount;
